<style>
    .vs-card--content {
        margin-bottom: 0;
    }
</style>

<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Checking and Packing</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-dropdown vs-trigger-click>
                            <vs-button class="btn mb-4 md:mb-0 mr-1" icon="settings_applications">Process</vs-button>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="finishPacking"> Finish Packing </vs-dropdown-item>
                                <vs-dropdown-item @click="cancelPacking"> Cancel Packing </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                        <vs-dropdown vs-trigger-click>
                            <vs-button class="btn mb-4 md:mb-0 mr-1" icon="print">Print</vs-button>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="printPackingList"> Packing List </vs-dropdown-item>
                                <vs-dropdown-item @click="printPackingLabel"> Packing Label </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                DO ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.id" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Reference
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.do_reference" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-tabs class="mt-10">
                    <vs-tab label="Scan">
                        <div class="vx-row mt-5">
                            <div class="vx-col lg:w-1/3 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Carton ID
                                    </div>
                                    <div class="vx-col w-3/5">
                                        <vs-input class="w-full" v-model="scan.packing_id"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Multiplier
                                    </div>
                                    <div class="vx-col w-3/5">
                                        <vs-input class="w-full" v-model="scan.multiplier"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        UoM
                                    </div>
                                    <div class="vx-col w-3/5">
                                        <vs-input class="w-full" v-model="scan.uom"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Item Code
                                    </div>
                                    <div class="vx-col w-3/5">
                                        <vs-input class="w-full" v-model="scan.product_code"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Pack ID
                                    </div>
                                    <div class="vx-col w-1/5">
                                          <vs-switch v-model="scan.is_pack_id" class="mt-1"/>
                                    </div>
                                    <div class="vx-col w-2/5">
                                        <vs-input class="w-full" v-model="scan.pack_id" :disabled="!scan.is_pack_id"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Batch
                                    </div>
                                    <div class="vx-col w-1/5">
                                          <vs-switch v-model="scan.is_batch" class="mt-1"/>
                                    </div>
                                    <div class="vx-col w-2/5">
                                        <vs-input class="w-full" v-model="scan.batch" :disabled="!scan.is_batch"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Box ID
                                    </div>
                                    <div class="vx-col w-1/5">
                                          <vs-switch v-model="scan.is_box_id" class="mt-1"/>
                                    </div>
                                    <div class="vx-col w-2/5">
                                        <vs-input class="w-full" v-model="scan.box_id" :disabled="!scan.is_box_id"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Expired Date
                                    </div>
                                    <div class="vx-col w-1/5">
                                          <vs-switch v-model="scan.is_expired_date" class="mt-1"/>
                                    </div>
                                    <div class="vx-col w-2/5">
                                        <flat-pickr class="w-full" v-model="scan.expired_date" :disabled="!scan.is_expired_date"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Stock Type
                                    </div>
                                    <div class="vx-col w-3/5">
                                        <v-select :options="stockTypes" v-model="scan.stock_type" label="name" @search="searchStockType"></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/3 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Packing Type
                                    </div>
                                    <div class="vx-col w-3/5">
                                        <v-select :options="packingTypes" v-model="scan.packing_type" label="code" @search="searchPackingType" @input="handlePackingChange(false)"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Length
                                    </div>
                                    <div class="vx-col w-3/5">
                                        <vs-input class="w-full" v-model="scan.length" placeholder="0.00"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Width
                                    </div>
                                    <div class="vx-col w-3/5">
                                        <vx-input-group>
                                            <template slot="append">
                                                <div class="append-text bg-primary">
                                                    <span>CM</span>
                                                </div>
                                            </template>
                                            <vs-input v-model="scan.width" placeholder="0.00"/>
                                        </vx-input-group>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/5">
                                        Height
                                    </div>
                                    <div class="vx-col w-3/5">
                                        <vs-input class="w-full" v-model="scan.height" placeholder="0.00"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <vs-button color="primary" class="btn mt-5 mr-1 mb-5" @click="scanItem">Scan</vs-button>
                        <vs-divider> LAST SCANNED ITEM </vs-divider>
                        <h1 v-show="last_scan.state">{{ last_scan.product_code }} - {{ last_scan.description_1 }} ({{ last_scan.multiplier }} {{ last_scan.base_uom }})</h1>
                    </vs-tab>
                    <vs-tab label="Checked Items">
                        <div class="flex items-center">
                            <vs-button color="primary" class="btn mb-5 mt-5 mr-1" @click="cancelCheck">Cancel Check</vs-button>
                            <vs-button color="primary" class="btn mb-5 mt-5 mr-1" @click="getPacking">Update Packing</vs-button>
                            <vs-button color="primary" class="btn mb-5 mt-5" @click="removePacking">Remove Packing</vs-button>
                        </div>
                        <vs-table multiple :data="data.checked_items" stripe v-model="selected" :hoverFlat="true">
                            <template slot="thead">
                                <vs-th>Packing ID</vs-th>
                                <vs-th>Product ID</vs-th>
                                <vs-th>Description</vs-th>
                                <vs-th>Pack ID</vs-th>
                                <vs-th>Batch</vs-th>
                                <vs-th>Box ID</vs-th>
                                <vs-th>Expired Date</vs-th>
                                <vs-th>Check Qty</vs-th>
                                <vs-th>Check UoM</vs-th>
                                <vs-th>Base Qty</vs-th>
                                <vs-th>Base UoM</vs-th>
                                <vs-th>Stock Type</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                    <vs-td>
                                        {{ tr.packing_id }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.product_code }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.description }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.pack_id }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.batch }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.box_id }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.expired_date }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.check_qty }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.check_uom }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.check_base_qty }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.base_uom }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.stock_type }}
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                    <vs-tab label="Outstanding">
                        <div class="flex items-center">
                            <vs-button color="primary" class="btn mb-5 mt-5 mr-1" @click="fetchAllData">Refresh</vs-button>
                        </div>
                        <vs-table :data="data.outstanding" stripe>
                            <template slot="thead">
                                <vs-th>Product ID</vs-th>
                                <vs-th>Description</vs-th>
                                <vs-th>Pack ID</vs-th>
                                <vs-th>Batch</vs-th>
                                <vs-th>Box ID</vs-th>
                                <vs-th>Expired Date</vs-th>
                                <vs-th>Base Qty</vs-th>
                                <vs-th>Base UoM</vs-th>
                                <vs-th>Stock Type</vs-th>
                            </template>
                            <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>
                                    {{ tr.product_code }}
                                </vs-td>
                                <vs-td>
                                    {{ tr.description_1 }}
                                </vs-td>
                                <vs-td>
                                    {{ tr.pack_id }}
                                </vs-td>
                                <vs-td>
                                    {{ tr.batch }}
                                </vs-td>
                                <vs-td>
                                    {{ tr.box_id }}
                                </vs-td>
                                <vs-td>
                                    {{ tr.expired_date }}
                                </vs-td>
                                <vs-td>
                                    {{ tr.outstanding_qty }}
                                </vs-td>
                                <vs-td>
                                    {{ tr.base_uom }}
                                </vs-td>
                                <vs-td>
                                    {{ tr.stock_type }}
                                </vs-td>
                            </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                </vs-tabs>
            </vs-card>
        </div>
        <vs-prompt
            @accept="updatePackaging"
            :active.sync="showPackingDialog"
            title="Update Packing"
            >
            <div class="con-exemple-prompt">
                <vs-input label="DO ID" v-model="packing_data.do_id" class="mb-2 w-full" disabled/>
                <vs-input label="Reference" v-model="packing_data.do_reference" class="mb-2 w-full" disabled/>
                <vs-input label="Packing ID" v-model="packing_data.packing_id" class="mb-2 w-full" disabled/>
                <label class="vs-input--label">Packing Type</label>
                <v-select :options="packingTypes" v-model="packing_data.packing_type" label="code" @search="searchPackingType" @input="handlePackingChange(true)" class="mb-2 w-full"></v-select>
                <vs-input label="Length" v-model="packing_data.length" class="mb-2 w-full"/>
                <vs-input label="Width" v-model="packing_data.width" class="mb-2 w-full"/>
                <vs-input label="Height" v-model="packing_data.height" class="mb-2 w-full"/>
                <vs-input label="Weight" v-model="packing_data.weight" class="mb-2 w-full"/>
            </div>
        </vs-prompt>
        <vs-prompt
            @accept="finishPacking"
            :active.sync="setTransporterDialog"
            title="Update Transporter ID"
            >
            <div class="con-exemple-prompt">
                <vs-input label="DO ID" v-model="data.id" class="mb-2 w-full" disabled/>
                <vs-input label="Reference" v-model="data.do_reference" class="mb-2 w-full" disabled/>
                <label class="vs-input--label">Transporter ID</label>
                <v-select :options="transporterOptions" v-model="set_transporter_id" label="transporter_code" class="mb-2 w-full"></v-select>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
                isLoading: false,
                data: {
                    id: '',
                    reference: '',
                    outstanding: [],
                    checked_items: [],
                },
                scan: {
                    packing_id: '',
                    multiplier: 1,
                    product_code: '',
                    pack_id: '',
                    batch: '',
                    box_id: '',
                    expired_date: '',
                    is_pack_id: false,
                    is_batch: false,
                    is_box_id: false,
                    is_expired_date: false,
                    stock_type: '',
                    packing_type: '',
                    length: '',
                    width: '',
                    height: '',
                    uom: ''
                },
                last_scan: {
                    product_code: '',
                    multiplier: '',
                    description_1: '',
                    state: false,
                    base_uom: ''
                },
                stockTypes: [],
                packingTypes: [],
                selected: [],
                showPackingDialog: false,
                packing_data: {
                    packing_id: '',
                    do_id: '',
                    reference: '',
                    packing_id: '',
                    packing_type: '',
                    packing_type_id: '',
                    length: '',
                    width: '',
                    height: '',
                    weight: ''
                },
                set_transporter_id: null,
                transporterOptions: [],
                setTransporterDialog: false
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            back() {
                this.$router.push({
                    name: 'delivery-order-view',
                    params: {
                        id: this.$route.params.id
                    }
                })
            },
            fetchAllData() {
                this.isLoading = true
                Promise.all([this.$http.get('outbound/deliveryorder/get_check_list/' + this.$route.params.id)])
                .then(this.$http.spread((res) => {
                    this.isLoading = false
                    this.data = res.data
                }))
                .catch(error => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.fetchAllData()
                        },
                        cancel: () => {
                            this.$router.push({
                                name: 'delivery-order-view',
                                params: {
                                    id: this.$route.params.id
                                }
                            })
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    })
                })
            },
            scanItem() {
                let error = false
                const data = {
                    do_id: this.$route.params.id,
                    packing_id: this.scan.packing_id,
                    multiplier: this.scan.multiplier,
                    product_code: this.scan.product_code,
                    pack_id: this.scan.pack_id ? this.scan.pack_id : null,
                    batch: this.scan.batch ? this.scan.batch : null,
                    box_id: this.scan.box_id ? this.scan.box_id : null,
                    expired_date: this.scan.expired_date ? this.scan.expired_date : null,
                    stock_type_id: this.scan.stock_type ? this.scan.stock_type.id : '',
                    packing_type_id: this.scan.packing_type ? this.scan.packing_type.id : '',
                    width: this.scan.width,
                    length: this.scan.length,
                    height: this.scan.height,
                    uom: this.scan.uom
                }

                data.do_id = this.$route.params.id
                
                if(!this.scan.stock_type.id) {
                    error = true
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Stock type is required.'
                    })
                }

                if(!this.scan.packing_type.id) {
                    error = true
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Packing is required.'
                    })
                }

                if(this.scan.multiplier < 1) {
                    error = true
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Multipier cannot be lower than 1.'
                    })
                }

                if(!this.scan.product_code) {
                    error = true
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Product code is required.'
                    })
                }

                if(error) {
                    return false
                }

                this.isLoading = true
                this.$http.post('outbound/deliveryorder/check/scan_item', data)
                .then(res => {
                    this.last_scan = res.data.last_scan
                    this.data.checked_items = res.data.data.checked
                    this.data.outstanding = res.data.data.outstanding
                    this.last_scan.state = true
                    this.isLoading = false

                    const message = res.data.message ? res.data.message : 'Success'
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: message
                    })
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
            },
            removeItem() {
                const data = this.selected.map(item => {
                    return item.check_id
                })

                if(data.length < 1) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No data selected.'
                    })
                    return false
                }

                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Confirm',
                    text: `Are you sure want to remove ${data.length} item(s)?`,
                    accept: () => {
                        this.isLoading = true
                        this.$http.post('outbound/deliveryorder/check/remove_item', {check_id: data})
                        .then(res => {
                            this.isLoading = false
                            this.selected = []
                            this.data.checked_items = res.data.data.checked_items
                            this.data.outstanding = res.data.data.outstanding
                            this.$vs.notify({
                                color: 'success',
                                title: 'Success',
                                iconPack: 'feather',
                                icon:'icon-check',
                                text: 'Data removed successfully.'
                            })
                        })
                        .catch(error => {
                            const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                            this.isLoading = false
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: message
                            })
                        })
                    }
                })
            },
            getPacking() {
                const ids = this.selected.map(item => {
                    return item.id
                })

                if(ids.length < 1) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No data selected.'
                    })
                    return false
                }

                const id = ids[0]

                this.isLoading = true
                this.$http.post('outbound/deliveryorder/check/get_packing', {id: id})
                .then(res => {
                    this.isLoading = false
                    this.showPackingDialog = true
                    this.packing_data = res.data

                    this.packingTypes.map(item => {
                        if(item.id == this.packing_data.packing_type_id) {
                            this.packing_data.packing_type = item
                        }
                    })

                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
            },
            removePacking() {
                const ids = this.selected.map(item => {
                    return item.id
                })

                if(ids.length < 1) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No data selected.'
                    })
                    return false
                }

                const data = {
                    do_id: this.$route.params.id,
                    check_id: ids
                }

                this.isLoading = true
                this.$http.post('outbound/check/removepacking', data)
                .then(res => {
                    this.isLoading = false
                    this.data = res.data
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: res.data.message
                    })
                    this.selected = []
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
            },
            cancelCheck() {
                const ids = this.selected.map(item => {
                    return item.id
                })

                if(ids.length < 1) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No data selected.'
                    })
                    return false
                }

                const data = {
                    do_id: this.$route.params.id,
                    check_id: ids
                }

                this.isLoading = true
                this.$http.post('outbound/check/cancelcheck', data)
                .then(res => {
                    this.isLoading = false
                    this.data = res.data
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: res.data.message
                    })

                    this.selected = []
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
            },
            updatePackaging() {
                this.isLoading = true
                const data = {
                    packing_type_id: this.packing_data.packing_type.id,
                    id: this.packing_data.id,
                    weight: this.packing_data.weight,
                    height: this.packing_data.height,
                    length: this.packing_data.length,
                    width: this.packing_data.width,
                }

                this.$http.post('outbound/deliveryorder/check/update_packing', data)
                .then(res => {
                    this.isLoading = false
                    const message = res.data.message ? res.data.message : 'Success.'
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: message
                    })
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
            },
            searchPackingType(search, loading) {
                loading(true)

                const data = {
                    code: search
                }

                this.$http.post('master/packaging/filter/dropdown', data)
                .then(res => {
                    this.packingTypes = res.data
                    loading(false)
                })
            },
            searchStockType(search, loading) {
                loading(true)

                const data = {
                    name: search
                }

                this.$http.post('master/stocktypes/filter/dropdown', data)
                .then(res => {
                    this.stockTypes = res.data
                    loading(false)
                })
            },
            handlePackingChange(update) {
                if(update) {
                    this.packing_data.height = this.packing_data.packing_type ? this.packing_data.packing_type.height : ''
                    this.packing_data.width = this.packing_data.packing_type ? this.packing_data.packing_type.width : ''
                    this.packing_data.length = this.packing_data.packing_type ? this.packing_data.packing_type.length : ''
                }
                else {
                    this.scan.height = this.scan.packing_type ? this.scan.packing_type.height : ''
                    this.scan.width = this.scan.packing_type ? this.scan.packing_type.width : ''
                    this.scan.length = this.scan.packing_type ? this.scan.packing_type.length : ''
                }
            },
            printPackingList() {
                this.isLoading = true
                this.$http.post('outbound/deliveryorder/check/print_packing_list', {id: this.$route.params.id}, { responseType: 'blob' })
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .catch(error => {
                    var reader = new FileReader()
                    const globalThis = this
                    reader.onload = function() {
                        globalThis.isLoading = false
                        const object = JSON.parse(reader.result)
                        const message = object.message ? object.message : 'Something went wrong'

                        globalThis.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: message
                        })
                    }
                    reader.readAsText(error.response.data)
                })
            },
            printPackingLabel() {
                this.isLoading = true
                this.$http.post('outbound/deliveryorder/check/print_packing_label', {id: this.$route.params.id}, { responseType: 'blob' })
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .catch(error => {
                    var reader = new FileReader()
                    const globalThis = this
                    reader.onload = function() {
                        globalThis.isLoading = false
                        const object = JSON.parse(reader.result)
                        const message = object.message ? object.message : 'Something went wrong'

                        globalThis.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: message
                        })
                    }
                    reader.readAsText(error.response.data)
                })
            },
            finishPacking() {
                this.isLoading = true

                const data = {
                    id: this.$route.params.id
                }

                if(this.set_transporter_id) {
                    data.transporter_id = this.set_transporter_id.id
                }

                this.$http.post('outbound/deliveryorder/check/finish_packing', data)
                .then(res => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-x',
                        time: 5000,
                        text: 'Packing completed. Click here to print packing label',
                        click: () => this.printPackingLabel()
                    })
                })
                .catch(error => {
                    this.set_transporter_id = null
                    if(error.response.data.message == 'DO transporter ID is empty.') {
                        this.$http.post('master/transporters/filter/dropdown')
                        .then(res => {
                            this.isLoading = false
                            this.transporterOptions = res.data
                            this.setTransporterDialog = true
                        })
                    }
                    else {
                        this.isLoading = false
                        const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: message
                        })
                    }
                })
            },
            cancelPacking() {

            }
        },
        mounted(){
            this.fetchAllData()
        },
	}
</script>